export const paths = {
	LANDING_PAGE: "/",

	// Solutions
	SOLUTIONS_BUSINESS: "/solutions/business",
	SOLUTIONS_PERSONAL: "/solutions/personal",

	// Support
	SUPPORT: "/contact",

	// Developers
	DEVELOPERS: "/developers",

	// Company
	ABOUT: "/about",
	CONTACT: "/contact",

	// Documentation routes
	DOCS: "/docs",
	DOCS_GETTING_STARTED: "/docs/getting-started",
	DOCS_AUTHENTICATION: "/docs/authentication",
	DOCS_GIFT_CARDS: "/docs/gift-cards",
	DOCS_INVESTMENT_CERTIFICATES: "/docs/investment-certificates",
	DOCS_TRANSACTIONS: "/docs/transactions",
	DOCS_LOYALTY: "/docs/loyalty",
	DOCS_QR_CODES: "/docs/qr-codes",
	DOCS_SETTLEMENTS: "/docs/settlements",
	DOCS_USER_MANAGEMENT: "/docs/user-management",
	DOCS_WEBHOOKS: "/docs/webhooks",
	DOCS_ERROR_HANDLING: "/docs/error-handling",
	DOCS_RATE_LIMITS: "/docs/rate-limits",
	DOCS_SDKS: "/docs/sdks",
	DOCS_ANDROID_SDK: "/docs/sdks/android",
	DOCS_IOS_SDK: "/docs/sdks/ios",
	DOCS_FLUTTER_SDK: "/docs/sdks/flutter",
	DOCS_JAVASCRIPT_SDK: "/docs/sdks/javascript",
	DOCS_TESTING: "/docs/testing",
	DOCS_SUPPORT: "/docs/support",

	// Gift Card Share
	GIFT_CARD_SHARE: "/gift-cards/:id",

	// Pay (merchant QR scan)
	PAY: "/pay/:qrId",
};
